export const itemInactiveClassName = 'text-secondary font-medium'

export const itemActiveClassName = 'text-primary bg-neutral-300 dark:bg-neutral-700'

export const itemHoverActiveClasName =
    'dark:hover:bg-neutral-700 hover:text-primary dark:active:bg-neutral-800 hover:bg-neutral-200 active:bg-neutral-300 active:text-primary'
